import { createElement, type ReactNode } from 'react'

export const Card = ({
  as = 'div',
  children,
  className,
}: {
  as?: 'article' | 'section' | 'div'
  children: ReactNode
  className?: string
}) => createElement(as, { className: ['card', className].filter(Boolean).join(' ') }, children)
